<template>
    <div v-if="SlotObj">
  
      <!-- {{getTimeDisplay(SlotObj.slot_start_ts)}} -->
      <button v-if="SlotObj.capacity < 1" type="button"
        class="w-full text-center text-gray-300 m-1 border rounded-md border-gray-300 p-1 sm:px-3 sm:py-2 text-xs cursor-not-allowed"
        :aria-label="`时段 ${getTimeDisplay(SlotObj.slot_start_ts)}，已约满（诊所当地时间）`"
        tabindex="0">
        <div class="flex-nowrap">
          {{getTimeDisplay(SlotObj.slot_start_ts)}}
        </div>
        <div>
          已约满
        </div>
      </button>
      <button v-else-if="selectedAppointmentSlot == SlotObj.slot_start_ts" type="button"
        class="w-full items-center rounded-md bg-primaryBtnHover border border-primaryBtn p-2 text-sm font-light text-white shadow-sm "
        :aria-label="`已选择时段 ${getTimeDisplay(SlotObj.slot_start_ts)}（诊所当地时间）`"
        tabindex="0"
        @keydown.enter.prevent="setSelectedAppointmentSlot(SlotObj.slot_start_ts)"
        @keydown.space.prevent="setSelectedAppointmentSlot(SlotObj.slot_start_ts)">
        <div>
          {{getTimeDisplay(SlotObj.slot_start_ts)}}
        </div>

        <div class="font-bold">
          已选择
        </div>
      </button>
  
      <button v-else @click="setSelectedAppointmentSlot(SlotObj.slot_start_ts)" type="button"
        class="w-full items-center rounded-md border border-primaryBtn/70 hover:bg-primaryBtn/80 hover:text-white p-2 text-sm font-light text-primaryText shadow-sm"
        :aria-label="`选择时段 ${getTimeDisplay(SlotObj.slot_start_ts)}（诊所当地时间）`"
        tabindex="0"
        @keydown.enter.prevent="setSelectedAppointmentSlot(SlotObj.slot_start_ts)"
        @keydown.space.prevent="setSelectedAppointmentSlot(SlotObj.slot_start_ts)"> 
            <div class="flex-nowrap">{{getTimeDisplay(SlotObj.slot_start_ts)}}</div>
            <div>可预约</div>
            
      </button>
      
      
  
      
    </div>
  </template>
  
  <script setup>
const {
    selectedAppointmentSlot, setSelectedAppointmentSlot
} = usePatientAppointmentRequest()
  
      const props = defineProps ({
          SlotObj: Object
      })
  
        const { formatClinicTimeFromISO } = useClinicTimezone()
        const getTimeDisplay = (ts) => formatClinicTimeFromISO(ts)
      
  
    
  
  </script>
  
  <style>
  
  </style>